module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"meta":{"title":"SIG and Enerfip Unveil Crowdfunding Campaign"},"title":"SIG and Enerfip Unveil Crowdfunding Campaign"},"es":{"meta":{"title":"Sig y Enerfip lanzan una campaña de Crowdfunding"},"title":"Sig y Enerfip lanzan una campaña de Crowdfunding"}}')
  delete Component.options._Ctor
}
